module.exports = __webpack_public_path__ + "img/Blog5.4.80fdfa45.png";